export default "__VITE_ASSET__YGLI99Q___"